import { CONFIRM_COLOR, CONFIRM_ICONS, TYPE_MODAL } from '../modal-confirm-notification';

export const ORDER_PAYMENT = {
    typeModal: TYPE_MODAL.NOTIFICATION,
    title: '¿Está seguro de emitir la venta?',
    valueButton: 'Aceptar',
    color: CONFIRM_COLOR.SUCCESS,
    iconSVG: CONFIRM_ICONS.SAVE
  };

  
export const REDIRECT_CREATE_QUOTATION = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  title: 'Para realizar la venta de un <b>producto medible</b>, por favor dirigirse al módulo de Cotizaciones.',
  valueButton: 'Ir a cotización',
  color: CONFIRM_COLOR.SUCCESS,
  iconSVG: CONFIRM_ICONS.NOTIFICATION
};

export const REDIRECT_CREATE_SERVICE = {
  typeModal: TYPE_MODAL.NOTIFICATION,
  title: `Para realizar la venta de un servicio, por favor dirigirse al módulo de Cotizaciones.`,
  valueButton: 'Ir a cotización',
  color: CONFIRM_COLOR.SUCCESS,
  iconSVG: CONFIRM_ICONS.NOTIFICATION
};
